module.exports = dibs_vendor;


//////////////////
// WEBPACK FOOTER
// external "dibs_vendor"
// module id = dll-reference dibs_vendor
// module chunks = 13